import React from "react";

interface PropsFromParent {
  text: string;
  icon?: JSX.Element;
  className: string;
  onClick: () => void;
}

export class DownloadButton extends React.PureComponent<PropsFromParent> {
  public render() {
    return (
      <div
        onClick={this.props.onClick}
        className={"flexDirectionRow " + this.props.className}
      >
        {this.props.icon}
        <div>{this.props.text}</div>
      </div>
    );
  }
}
